var React = require('react');

function DeleteScheduleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 3h16a1 1 0 0 1 1 1v2H3V4a1 1 0 0 1 1-1zM1 6V4a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v6a1 1 0 1 1-2 0V8H3v11a2 2 0 0 0 2 2h7a1 1 0 1 1 0 2H5a4 4 0 0 1-4-4V6zm13.909 7.75a.75.75 0 0 0-.73.927l.14.573h6.427l.128-.591a.75.75 0 0 0-.733-.909h-5.232zm5.513 3h-5.738l1.048 4.31a.25.25 0 0 0 .243.19h3.272a.25.25 0 0 0 .244-.197l.93-4.303zm-7.7-1.718a2.25 2.25 0 0 1 2.187-2.782h5.232a2.25 2.25 0 0 1 2.2 2.726l-1.383 6.394a1.75 1.75 0 0 1-1.71 1.38h-3.273a1.75 1.75 0 0 1-1.7-1.336l-1.553-6.382z","fill":"#fff"}));
}

DeleteScheduleIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DeleteScheduleIcon;

DeleteScheduleIcon.default = DeleteScheduleIcon;
